import { put } from "redux-saga/effects";
import { message } from "antd";
import { ApiCaller } from "../../config";
import { AIAction } from "../actions";

export default class AIMiddleware {
  static *addAIMessage({ payload, cb }) {
    try {
      const res = yield ApiCaller.Post(`/ai/addMessage`, payload);
      if (res.status === 200) {
        yield put(AIAction.addAIMessageSuccess(res.data.data));
      } else {
        yield put(AIAction.addAIMessageFailure());
        message.error(res.data.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(AIAction.addAIMessageFailure());
    }
  }
  static *getAIMessages({ payload, cb }) {
    try {
      const res = yield ApiCaller.Get(
        `/ai/getSessionMessages?sessionId=${payload.sessionId}`
      );
      if (res.status === 200) {
        yield put(AIAction.getAIMessagesSuccess(res.data.data));
      } else {
        yield put(AIAction.getAIMessagesFailure());
        message.error(res.data.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(AIAction.getAIMessagesFailure());
    }
  }
  static *getAISessions({ cb }) {
    try {
      const res = yield ApiCaller.Get(`/ai/getSessions`);
      if (res.status === 200) {
        yield put(AIAction.getAISessionsSuccess(res.data.data));
      } else {
        yield put(AIAction.getAISessionsFailure());
        message.error(res.data.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(AIAction.getAISessionsFailure());
    }
  }
  static *deleteAISession({ payload, cb }) {
    try {
      const res = yield ApiCaller.Delete(
        `/ai/deleteSession?sessionId=${payload.sessionId}`
      );
      if (res.status === 200) {
        yield put(AIAction.deleteAISessionSuccess(res.data.data));
        yield put(AIAction.getAISessions());
      } else {
        yield put(AIAction.deleteAISessionFailure());
        message.error(res.data.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(AIAction.deleteAISessionFailure());
    }
  }
  static *getAIDocs({ cb }) {
    try {
      const res = yield ApiCaller.Get(`/ai/getAiDocs`);
      if (res.status === 200) {
        yield put(AIAction.getAIDocsSuccess(res.data.data));
      } else {
        yield put(AIAction.getAIDocsFailure());
        message.error(res.data.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(AIAction.getAIDocsFailure());
    }
  }
}
